/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_State_WorkingInputs */

const en_inbox_state_working = /** @type {(inputs: Inbox_State_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in progress`)
};

const id_inbox_state_working = /** @type {(inputs: Inbox_State_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sedang dikerjakan`)
};

/**
* | output |
* | --- |
* | "in progress" |
*
* @param {Inbox_State_WorkingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_state_working = /** @type {((inputs?: Inbox_State_WorkingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_State_WorkingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_state_working(inputs)
	return en_inbox_state_working(inputs)
});